import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import Chip from "@mui/material/Chip";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Link from "@mui/material/Link";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";

import { FaFileCode } from "react-icons/fa";
import { FaMobile } from "react-icons/fa6";
import { SiVorondesign } from "react-icons/si";
import { IoIosApps } from "react-icons/io";
import { MdAppRegistration } from "react-icons/md";
import { FaCloud } from "react-icons/fa6";
import { MdOutlineSettingsSuggest } from "react-icons/md";
import { SiSimilarweb } from "react-icons/si";

import { Wrapper } from "../layout/Wrapper";
import { ToolTabs } from "../components/ToolTabs";
import { alpha, useTheme } from "@mui/material";
import { useNavigate } from "react-router-dom";

const items = [
  {
    icon: <FaFileCode size={25} />,
    title: "Custom Software Development",
    description:
      "We design and develop tailored software solutions that align with your specific business objectives, ensuring maximum efficiency and effectiveness.",
    // tools: ["React", "Angular", "Vue.js"],
  },
  {
    icon: <SiSimilarweb size={20} />,
    title: "Web Application Development",
    description:
      "Our team creates interactive web applications using cutting-edge frameworks and technologies, enhancing user engagement and delivering a seamless browsing experience.",
  },
  {
    icon: <IoIosApps size={25} />,
    title: "Software Integration",
    description:
      "We connect various software systems and applications, streamlining processes and improving operational efficiency to create a cohesive workflow.",
  },
  {
    icon: <FaMobile size={25} />,
    title: "Mobile App Development",
    description:
      "We specialize in comprehensive mobile app development, offering our expertise and delivering user-centric solutions that are aligned with your business objectives",
  },
  {
    icon: <MdAppRegistration size={25} />,
    title: "E-commerce & CMS Development",
    description:
      "We create robust e-commerce platforms with custom designs and secure payment integration, along with custom Content Management Systems for seamless content management and scalability.",
  },
  {
    icon: <FaCloud size={25} />,
    title: "Cloud Solutions",
    description:
      "Our expertise in cloud technology enables us to develop and deploy cloud-based applications and services, including SaaS, to enhance scalability and accessibility for your business.",
  },
  {
    icon: <SiVorondesign size={20} />,
    title: "UI/UX Design",
    description:
      "Our design team crafts intuitive user interfaces and experiences, focusing on user engagement and satisfaction to ensure that your applications are both appealing and easy to navigate.",
  },
  {
    icon: <MdOutlineSettingsSuggest size={25} />,
    title: "Maintenance and Support",
    description:
      "We offer ongoing maintenance and support services, ensuring that your software continues to operate smoothly, adapt to changing needs, and remain up to date with the latest technologies..",
  },
];
// const items = [
//   {
//     icon: <FaFileCode size={25} />,
//     title: "Front-end Development",
//     description:
//       "We offer comprehensive frontend UX/UI development services, crafting intuitive interfaces by leveraging modern frontend development tools to create sophisticated and responsive interfaces that enhance usability and achieve client goals effectively.",
//     // tools: ["React", "Angular", "Vue.js"],
//   },
//   {
//     icon: <LuServerCog size={25} />,
//     title: "Back-end Development",
//     description:
//       "We specialize in high-load robust and complex backend infrastructure development for mobile and web applications, as well as enterprise services, ensuring robust and scalable solutions for optimal performance and reliability.",
//   },
//   {
//     icon: <IoIosApps size={25} />,
//     title: "Full Stack App Development",
//     description:
//       "Combining frontend UX/UI expertise with backend proficiency, we deliver comprehensive solutions using modern technologies to meet diverse project requirements and optimize user-centric digital experiences.",
//   },
//   {
//     icon: <FaMobile size={25} />,
//     title: "Mobile App Development",
//     description:
//       "We specialize in comprehensive mobile app development, offering expertise from initial consultation and design to development, testing, and deployment, delivering user-centric solutions that are robust, scalable, and aligned with your business objectives",
//   },
//   {
//     icon: <MdAppRegistration size={25} />,
//     title: "Custom CMS Development",
//     description:
//       "We excel in custom CMS development, tailoring intuitive content management systems that empower businesses with flexible, scalable solutions for efficient content creation, management, and delivery across digital platforms.",
//   },
//   {
//     icon: <FaCloud size={25} />,
//     title: "DevOps & Cloud Solutions",
//     description:
//       "We offer DevOps and cloud solutions, implementing scalable infrastructure and automation tools to optimize deployment, monitoring, and management of applications for seamless performance and efficiency.",
//   },
//   {
//     icon: <MdOutlineSettingsSuggest size={25} />,
//     title: "Software Maintenance Services",
//     description:
//       "We provide comprehensive maintenance services to ensure software systems operate smoothly and securely. Services include bug fixes, updates, security audits, and performance optimizations for uninterrupted business operations and user satisfaction.",
//   },
// ];

const OurServicesPage = ({ mode, toggleColorMode }) => {
  const [selectedItemIndex, setSelectedItemIndex] = React.useState(0);

  const handleItemClick = (index) => {
    setSelectedItemIndex(index);
  };
  const navigate = useNavigate();
  const theme = useTheme();
  return (
    <Wrapper mode={mode} toggleColorMode={toggleColorMode}>
      <Box
        sx={(theme) => ({
          width: "100%",
          background:
            theme.palette.mode === "light"
              ? // ? "linear-gradient(180deg, #CEE5FD, #FFF)"
                "#f6f4fa"
              : `linear-gradient(#02294F, ${alpha("#090E10", 0.0)})`,
          backgroundSize: "100% 20%",
          backgroundRepeat: "no-repeat",
        })}
      >
        <Container
          id="ourServices"
          sx={{
            pt: { xs: 14, sm: 20 },
            pb: { xs: 8, sm: 10 },
            position: "relative",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: { xs: 3, sm: 6 },
          }}
        >
          <Box
            sx={{
              width: { sm: "100%", md: "60%" },
              textAlign: { sm: "center", md: "center" },
            }}
          >
            <Typography
              component="div"
              variant="body1"
              textAlign="center"
              sx={{
                color:
                  theme.palette.mode === "light"
                    ? theme.palette.secondary.main
                    : "#9043c6",
                fontWeight: "bold",
              }}
            >
              OUR SERVICES
            </Typography>
            <div>
              <Typography
                component="h2"
                variant="h4"
                color="text.primary"
                fontWeight="bold"
                textAlign="center"
                sx={{ lineHeight: { xs: "2.5rem" }, mt: 4, mb: 4 }}
              >
                Imagine. Innovate. Impact.
              </Typography>
              <Typography
                variant="body1"
                color="text.secondary"
                textAlign="center"
                sx={{ mb: { xs: 2, sm: 4 }, pt: { pt: 4 } }}
              >
                We offer range of tech services including software development
                with user-friendly interfaces and strong backend infrastructure,
                robust security, seamless integration, customizable workflows,
                analytics tools, plus mobile compatibility and cloud storage.
              </Typography>
            </div>
          </Box>

          <Grid
            container
            spacing={4}
            data-aos="fade-up"
            data-aos-duration="1000"
          >
            {items.map(({ icon, title, description, tools }, index) => (
              <Grid item key={index} sx={{ display: "flex" }} xs={12} md={6}>
                <Stack
                  direction="row"
                  justifyContent="center"
                  alignItems="flex-start"
                  spacing={2}
                  useFlexGap
                  sx={{
                    width: "100%",
                    display: "flex",
                  }}
                >
                  <Card
                    key={index}
                    variant="outlined"
                    component={Button}
                    onClick={() => handleItemClick(index)}
                    sx={{
                      p: 3,
                      height: "fit-content",
                      width: "200%",
                      background: "none",
                      backgroundColor:
                        selectedItemIndex === index
                          ? "action.selected"
                          : undefined,
                      borderColor: (theme) => {
                        if (theme.palette.mode === "light") {
                          return selectedItemIndex === index
                            ? "primary.light"
                            : "grey.200";
                        }
                        return selectedItemIndex === index
                          ? "primary.dark"
                          : "grey.800";
                      },
                    }}
                  >
                    <Box
                      mt={2}
                      sx={{
                        width: "100%",
                        display: "flex",
                        textAlign: "left",
                        flexDirection: { xs: "column", md: "row" },
                        alignItems: { md: "center" },
                        gap: 2.5,
                      }}
                    >
                      <Box
                        sx={{
                          color: (theme) => {
                            if (theme.palette.mode === "light") {
                              return selectedItemIndex === index
                                ? "primary.main"
                                : "grey.300";
                            }
                            return selectedItemIndex === index
                              ? "primary.main"
                              : "grey.700";
                          },
                        }}
                      >
                        {icon}
                      </Box>
                      <Box sx={{ textTransform: "none" }}>
                        <Typography
                          color="text.primary"
                          variant="body2"
                          fontWeight="bold"
                        >
                          {title}
                        </Typography>
                        <Typography
                          color="text.secondary"
                          variant="body2"
                          sx={{ my: 0.5, mt: 2 }}
                        >
                          {description}
                        </Typography>

                        <Typography
                          display="flex"
                          justifyContent="space-between"
                        >
                          <Stack direction="row" spacing={1} mt={3}>
                            {tools?.map((item, i) => (
                              <Chip label={item} />
                            ))}
                          </Stack>

                          <Link
                            color="primary"
                            variant="body2"
                            fontWeight="bold"
                            onClick={() => navigate("/get-a-quote")}
                            mt={3}
                            sx={{
                              display: "inline-flex",
                              alignItems: "center",
                              "& > svg": { transition: "0.2s" },
                              "&:hover > svg": { transform: "translateX(2px)" },
                            }}
                          >
                            <span>Lets talk</span>
                            <ChevronRightRoundedIcon
                              fontSize="small"
                              sx={{ mt: "1px", ml: "2px" }}
                            />
                          </Link>
                        </Typography>
                      </Box>
                    </Box>
                  </Card>
                </Stack>
              </Grid>
            ))}
          </Grid>

          <ToolTabs />
        </Container>
      </Box>
    </Wrapper>
  );
};
export default OurServicesPage;
